import { useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import Highlights from "../Component/Highlights";
import LazyLoad from "react-lazyload";
const Header = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <>
      <div className="header">
        <div className="logo">
          <NavLink to="/">
            <LazyLoad>
              <img
                src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SJSKBUP/public/Images/logo.png"
                alt="St. Joseph’s school, Barhalganj"
                className="img-fluid"
              />
            </LazyLoad>
          </NavLink>
        </div>
        <div className="header-nav">
          <Highlights />
          <nav className="navbar navbar-expand-lg">
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#main_nav"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="main_nav">
              <ul className="navbar-nav">
                <li className="nav-item ">
                  <NavLink to="/" className="nav-link">
                    Home
                  </NavLink>
                </li>

                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    About Us
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink className="dropdown-item" to="/about">
                        Our School
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/Administration">
                        Administration
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/MessageInner">
                        Principal’s Message
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/vision-mission">
                        Vision Mission
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/moto">
                        School Motto
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/infrastructure">
                        Infrastructure
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    <NavLink className="dropdown-item" to="/">
                      Academics
                    </NavLink>
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink className="dropdown-item" to="/curriculum">
                        Curriculum
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/exams">
                        Examination and Promotion
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/curricular">
                        Co-Curricular Activities
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/Attendance">
                        Attendance and Leave
                      </NavLink>
                    </li>

                    <li>
                      <NavLink className="dropdown-item" to="/AcademicCal">
                        Academic Calendar
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/Booklist">
                        Booklist
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/school-uniform">
                        School Uniform
                      </NavLink>
                    </li>
                  </ul>
                </li>
                {/* <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    <NavLink className="dropdown-item" to="/">
                      Results
                    </NavLink>
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink className="dropdown-item" to="/topperX">
                        ICSE Result
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/topperXII">
                        ISC Result
                      </NavLink>
                    </li>
                  </ul>
                </li> */}
                {/* <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    <NavLink className="dropdown-item" to="/">
                      Activity
                    </NavLink>
                  </div> */}
                {/* <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink className="dropdown-item" to="/">
                        Club
                      </NavLink>
                    </li>
                    <li> */}
                {/* <NavLink className="dropdown-item" to="/">
                        Calendar
                      </NavLink>
                    </li>
                    <li> */}
                {/* <NavLink className="dropdown-item" to="/">
                        Teachers' Blog
                      </NavLink>
                    </li>
                    <li> */}
                {/* <NavLink className="dropdown-item" to="/">
                        Students' Blog
                      </NavLink>
                    </li> */}
                {/* <li>
                      <NavLink className="dropdown-item" to="/">
                        Reflections
                      </NavLink>
                    </li> */}
                {/* </ul>
                </li>
                */}
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    <NavLink className="dropdown-item" to="/">
                      Prospects
                    </NavLink>
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink className="dropdown-item" to="/Registration">
                        Registration
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink className="dropdown-item" to="/">
                        Fees
                      </NavLink>
                    </li> */}
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/AdmissionandWithdrawal"
                      >
                        Admission and Withdrawal
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/ConductandDiscipline"
                      >
                        Conduct and Discipline
                      </NavLink>
                    </li>
                    <li>
                      <NavLink
                        className="dropdown-item"
                        to="/Recommendationtotheparents"
                      >
                        Recommendation to the parents
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/SchoolFee">
                        School Fee
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/BusRules">
                        Bus Rules
                      </NavLink>
                    </li>

                    {/* <li>
                      <NavLink className="dropdown-item" to="/school-uniform">
                        school-uniform
                      </NavLink>
                    </li> */}
                  </ul>
                </li>
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    <NavLink className="dropdown-item" to="/">
                      Gallery
                    </NavLink>
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink className="dropdown-item" to="/galleryinner">
                        Photo Gallery
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/VideoGallery">
                        Video Gallery
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink className="dropdown-item" to="/">
                        Magazine
                      </NavLink>
                    </li> */}
                  </ul>
                </li>

                {/* achievement header */}
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    <NavLink className="dropdown-item" to="/Achievement">
                      Achievement
                    </NavLink>
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink className="dropdown-item" to="/ISCEToppers">
                        ICSE Toppers
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/ISCToppers">
                        ISC Toppers
                      </NavLink>
                    </li>
                    {/* <li>
                      <NavLink className="dropdown-item" to="/">
                        Magazine
                      </NavLink>
                    </li> */}
                  </ul>
                </li>

                {/* <li className="nav-item">
                  <NavLink className="dropdown-item" to="/">
                    Careers
                  </NavLink>
                </li> */}
                <li className="nav-item dropdown">
                  <div className="nav-link" data-bs-toggle="dropdown">
                    <NavLink className="dropdown-item" to="/">
                      Contact Us
                    </NavLink>
                  </div>
                  <ul className="dropdown-menu fade-up">
                    <li>
                      <NavLink className="dropdown-item" to="/">
                        Contact
                      </NavLink>
                    </li>
                    <li>
                      <NavLink className="dropdown-item" to="/">
                        Suggestion
                      </NavLink>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Header;
